import { useState } from 'react';
import type { ScreenDef } from '@/lib/types';
import { ChangePasswordDialog } from '@/shell/ChangePasswordDialog';
import { useAuth } from '@/auth/AuthContext';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { confirmDialog } from '@/ui/confirm';
import { AppearancePanel } from '@/shell/Appearance';

/** Delphi Unit62 */
export function SifreDegistir(_: { screen: ScreenDef }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="p-6">
      <button className="btn btn-primary" onClick={() => setOpen(true)}>Şifre Değiştir</button>
      <ChangePasswordDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}

/** Delphi about.pas */
export function Hakkinda(_: { screen: ScreenDef }) {
  const { user } = useAuth();
  return (
    <div className="flex flex-1 items-start justify-center p-8">
      <div className="panel max-w-lg rounded-lg p-6">
        <div className="mb-2 flex items-center gap-3"><img src="/favicon.svg" className="h-10 w-10" alt="" /><div className="text-lg font-semibold">Dolphin Fırın · Unlu Mamüller Takip Sistemi</div></div>
        <p className="mb-2">Web sürümü — masaüstü programla aynı MSSQL veritabanı, metadata ve iş kurallarıyla çalışan yeni nesil arayüz.</p>
        <p className="text-xs muted">Şirket: {user?.companyName} · Kullanıcı: {user?.userName}</p>
      </div>
    </div>
  );
}

/** Delphi Unit77 (Program Renk Yönetimi): web'de kullanıcı bazında tasarım / mod / yoğunluk seçimi */
export function Tema(_: { screen: ScreenDef }) {
  return (
    <div className="flex-1 overflow-y-auto p-6 scroll-thin">
      <div className="card mx-auto max-w-[1400px] p-6">
        <h2 className="h-display text-2xl">Görünüm</h2>
        <p className="mb-6 mt-1 text-[13px] muted">Seçtiğiniz tasarım yalnız sizin hesabınıza kaydedilir; başka bilgisayardan girdiğinizde de aynı görünümle açılır.</p>
        <AppearancePanel />
      </div>
    </div>
  );
}

/** Tek düğmeli bakım işlemi (ör. Unit18_3 Kart Hareket Kontrolü): SP adı sunucuda Web_Screen.AYAR.islem'den okunur */
export function IslemCalistir({ screen }: { screen: ScreenDef }) {
  const islem = screen.settings?.islem ?? {};
  const [busy, setBusy] = useState(false);
  const [sonuc, setSonuc] = useState<string | null>(null);
  const run = async () => {
    if (!(await confirmDialog(islem.onay ?? `${screen.title} başlatılsın mı?`, { ok: 'Başlat' }))) return;
    setBusy(true);
    setSonuc(null);
    try {
      const r = await api<{ message: string; ms: number }>(`/screens/${screen.tag}/islem`, { method: 'POST' });
      setSonuc(`${r.message} (${(r.ms / 1000).toFixed(1)} sn)`);
      toast.success(r.message);
    } catch (e: any) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-1 items-start justify-center p-8">
      <div className="panel w-full max-w-xl rounded-lg p-6">
        <div className="mb-2 text-lg font-semibold">{screen.title}</div>
        <p className="mb-4 text-[13px] muted">{islem.aciklama ?? screen.description}</p>
        <button className="btn btn-primary" disabled={busy || !screen.rights.update} onClick={run}>{busy ? 'Çalışıyor… (uzun sürebilir)' : 'Başlat'}</button>
        {sonuc && <div className="mt-4 rounded bg-emerald-50 p-2 text-[13px] text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200">{sonuc}</div>}
      </div>
    </div>
  );
}
